import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { AuthProvider } from "./context/auth-context";
import MainLayout from "./layout";
import Home from "./layout/Home";
import ProductDetail from "./page/detail";
import LoginPage from "./page/login";
import ProductDetailPage from "./page/detailPage";
import ProductDetailPageTrans from "./page/detailProductPage";
import { StoreConfig } from "./tenant";

type AppProps = {
  store: StoreConfig | null;
};

const queryClient = new QueryClient();

function App({ store }: AppProps) {
  return (
    <QueryClientProvider client={queryClient}>
      <Router>
        <AuthProvider>
          <MainLayout>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/chi-tiet-san-pham/:id" element={<ProductDetail />} />
              <Route path="/danh-muc-san-pham" element={<ProductDetailPage />} />
              <Route path="/dang-nhap" element={<LoginPage />} />
              <Route path="/danh-muc-san-pham/:slug/:id" element={<ProductDetailPageTrans />} />
            </Routes>
          </MainLayout>
        </AuthProvider>
      </Router>
    </QueryClientProvider>
  );
}

export default App;
